import { render, staticRenderFns } from "./SystemStatus.vue?vue&type=template&id=10db16d8&scoped=true&"
import script from "./SystemStatus.vue?vue&type=script&lang=js&"
export * from "./SystemStatus.vue?vue&type=script&lang=js&"
import style0 from "./SystemStatus.vue?vue&type=style&index=0&id=10db16d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10db16d8",
  null
  
)

export default component.exports